export default __webpack_public_path__ + "images/select-business-hours.svg";